export class QTGroupStorageItem {
    constructor(tableColumns, calculator, groupByColumnIndex) {
        this.groupHeaderRow = null;
        // For lookup.
        this.groupRowsDict = {};
        // For viewing.
        this.groupRowsArray = [];
        // Fucking sorting
        this.GroupIndex = null;
        this.columnAggregates = new Map();
        this.columns = tableColumns;
        this.calculator = calculator;
        this.groupByColumnIndex = groupByColumnIndex;
        for (const column of tableColumns) {
            if (!column.isShowGroupTotal()) {
                continue;
            }
            this.columnAggregates.set(column.PRIVATE.index, '');
        }
    }
    recalculateAggregates(showTotals) {
        if (!this.groupHeaderRow.isDisplayed) {
            return;
        }
        this.columnAggregates.forEach((aggregate, columnIndex) => {
            if (this.columns[columnIndex].visible) {
                this.columnAggregates.set(columnIndex, this.calculator.getColumnAggregate(columnIndex, this.groupRowsArray, this.groupByColumnIndex, showTotals));
            }
        });
    }
}
